var EvaluationBox = require("components/writing/evaluations/EvaluationBox");
var UserAvatar = require("components/avatars/UserAvatar");
var StandInAvatar = require("components/avatars/StandInAvatar");
var NameLookup = require("lib/data/NameLookup");

require("writing/responses/student_activity_info_line.scss")

class StudentActivityInfoLine extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var response = this.props.response;
		if (this.props.response.text && response.text.title) {
			var title = response.text.title;
		} else {
			var title = "Text provided";
		}

		if (this.props.user) {

			if (this.props.user.unsorted) {
				var mainUser = (
					<span>
						<StandInAvatar admin={ this.props.user } maxWidth={ 30 } />{" "}
						{ response.input_name }
					</span>
				)

			} else {
				var mainUser = (
					<span>
						<UserAvatar user={ this.props.user } maxWidth={ 30 } />{" "}
						{ this.props.user.display_name }
					</span>
				);
			}

			if (response.mirror_user_ids && NameLookup.isLoaded()) {
				var mirrorIDs = _.without(response.mirror_user_ids, this.props.user.id);
				var otherNames = NameLookup.getNames(mirrorIDs);

				var otherUsers = (<span>{ ", " + otherNames.join(", ") }</span>);
			}

			var userLine = (
				<span className="responseUserLine">
					{ mainUser }{ otherUsers }<br />
				</span>
			);
		}
		if (response.edited_at) {
			var edited = (<div className="editedInfo">Edited: { $wr.formatDate(response.edited_at)}</div>)
		}
		var studentInfo = (
			<div className="studentInfoContainer">
				{ userLine }
				<em>{ title }</em><br />
				Completed: { $wr.formatDate(response.created_at) }
				{edited}
			</div>
		)
		return (
			<div>
				{ studentInfo }
			</div>	
		)
	}

	componentDidMount() {
		if (!NameLookup.isLoaded() && this.props.user && this.props.response.mirror_user_ids
			&& this.props.response.mirror_user_ids.length > 1) {

			NameLookup.loadStudentNames(function() {
				this.forceUpdate();
			}.bind(this));
		}
	}
};

StudentActivityInfoLine.propTypes = StrictPropTypes({
	// The activity
	response: PropTypes.object.isRequired,

	// If this is present, we'll show the student and the avatar
	user: PropTypes.object
});

module.exports = StudentActivityInfoLine;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/StudentActivityInfoLine.js